import snakecaseKeys from 'snakecase-keys'
import type { AxiosRequestTransformer } from 'axios'

export const toSnakecase: AxiosRequestTransformer = data => {
  if (data) {
    return JSON.stringify(snakecaseKeys(data, { deep: true }))
  }
  return undefined
}
